import React, { useState, useEffect, useContext } from 'react';
import { Stack, Tabs, Tab, Box, Container } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAccountDetails } from '../../api/settings';
import { getConsigmentDetails, getShipmentStatusForShipmentView, getErrorsDetails } from '../../api/dashboard';
import PropTypes from 'prop-types';
import { StoreContext } from '../../components/Store';
import DashboardHeaderShipment from './DashboardHeaderShipment';
import Paper from '@mui/material/Paper';
import WarningIcon from '@mui/icons-material/Warning';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DuplicateModal, DeleteShipmentModal } from '../Decs/Modals/MenuBarModals';
import RefreshStatusModal from '../Decs/Modals/RefreshStatusModal';
import { dateFormatChange } from '../../utils/date';
import { is360PayStaff, isEORIUser } from '../../utils/roles';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
const paginationModel = { page: 0, pageSize: 50 };
export default function ShipmentView() {
  const { state } = useLocation();
  const [shipmentDataView, setShipmentDataView] = useState([]);
  const [consignmentDataView, setConsignmentDataView] = useState([]);
  const [value, setValue] = useState(0);
  const store = useContext(StoreContext);
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [acceptedStated, setAcceptedStated] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [deleteShipmentModalOpen, setDeleteShipmentModalOpen] = useState(false);
  const [refreshStatusModalOpen, setRefreshStatusModalOpen] = useState(false);
  const [companyName, setCompanyName] = useState({});
  const [logoImage, setLogoImage] = useState('');
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const apiCallForShipmentData = (headerId, companyId) => {
    getShipmentStatusForShipmentView(headerId, companyId).then((data) => {
      for (var i = 0; i < data.data.length; i++) {
        if (data.data[i]['status'].toUpperCase() === 'ACCEPTED') {
          setAcceptedStated(true);
        }
      }
      var error = data.data?.find((e) => e.status.toUpperCase() === 'ERRORS');
      if (error) {
        setIsError(true);
      }
      var rejected = data.data?.find((e) => e.status.toUpperCase() === 'REJECTED');
      if (rejected) {
        setIsRejected(true);
      }
      setShipmentDataView(data.data);
    });
  };

  const getConsignmentDetailsData = (headerId, companyId) => {
    getConsigmentDetails(headerId, companyId).then((data) => {
      for (var i = 0; i < data.data.length; i++) {
        if (data.data[i]['status'].toUpperCase() === 'ERRORS') {
          setIsError(true);
        }
        if (data.data[i]['status'].toUpperCase() === 'REJECTED') {
          setIsRejected(true);
        }
      }
      setConsignmentDataView(data.data);
    });
  };
  const apiCallForAccountDetails = () => {
    getAccountDetails(state.companyId).then((data) => {
      if (isEORIUser()) {
        if (state.companyId == data.companyId) {
          var binary = '';
          if (data.logo) {
            var bytes = new Uint8Array(data.logo?.data);
            var len = bytes.byteLength;
            for (var j = 0; j < len; j++) {
              binary += String.fromCharCode(bytes[j]);
            }
            setLogoImage(btoa(binary));
          }
          setCompanyName({
            companyName: data.company,
            companyEori: data.eori,
          });
        }
      }

      if (data.customerTypeId === 40 || is360PayStaff()) {
        setIsReadOnly(true);
      }
    });
  };
  useEffect(() => {
    async function fetchData() {
      try {
        apiCallForShipmentData(state.res, state.companyId);
        getConsignmentDetailsData(state.res, state.companyId);
        apiCallForAccountDetails();
      } catch (err) {
        console.log(err);
      }
    }
    if (shouldFetchData) {
      fetchData();
      setShouldFetchData(false);
    }
  }, [shouldFetchData]);

  const handleClick = (dataClickedItem) => {
    if (Object.keys(dataClickedItem).length > 0 && dataClickedItem.constructor === Object) {
      console.log(dataClickedItem);
    }
  };
  const handleClickConsignment = (dataClickedItem) => {
    console.log(dataClickedItem);
  };

  const columns = [
    {
      field: 'clientJobNumber',
      headerName: 'Your Reference',
      flex: 1,
      headerClassName: 'theme--header',
      editable: false,
    },
    {
      field: 'vehicleIdentity',
      headerName: 'Vehicle Identity',
      flex: 1,
      headerClassName: 'theme--header',
      editable: false,
    },
    {
      field: 'departureDate',
      headerName: 'Departure Date',
      type: 'number',
      flex: 1,
      headerClassName: 'theme--header',
      editable: false,
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => <div>{params.row.departureDate ? dateFormatChange(params.row.departureDate) : ''}</div>,
    },
    {
      field: 'arrivalDateTime',
      headerName: 'Arrival Date',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => (
        <div>{params.row.arrivalDateTime ? dateFormatChange(params.row.arrivalDateTime) : ''}</div>
      ),
    },
    {
      field: 'totalConsignments',
      headerName: 'Number of Consignments',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      headerAlign: 'center',
      renderCell: (params) => {
        if (params.value.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                backgroundColor: '#FFB4B0',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {params.value}
            </Box>
          );
        }
        if (params.value.toUpperCase() === 'ACCEPTED') {
          return (
            <Box
              sx={{
                backgroundColor: '#AEDD94',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {params.value}
            </Box>
          );
        }
        return (
          <Box
            sx={{
              backgroundColor: '#fff',
              width: '100%',
              height: '100%',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'click',
      headerName: '',
      width: 50,
      editable: false,
      headerClassName: 'theme--header',
      renderCell: (params) => (
        <div
          onClick={() =>
            navigate('/EnsDeclaration', {
              state: {
                headerId: state.res,
                companyId: state.companyId,
                error: params.row.status.toUpperCase() === 'ERRORS' ? true : false,
                image: logoImage,
                currentCompany: companyName,
                isReadOnly,
              },
            })
          }
        >
          <ExitToAppIcon className="svg-icons" style={{ color: '#1464F6' }} />
        </div>
      ),
    },
  ];
  const consignmentColumns = [
    {
      field: 'consignor',
      headerName: 'Consignor',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      renderCell: (params) => {
        if (params.row.status.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                color: '#E61610',
              }}
            >
              {params.value}
            </Box>
          );
        }
      },
    },

    {
      field: 'consignee',
      headerName: 'Consignee',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      renderCell: (params) => {
        if (params.row.status.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                color: '#E61610',
              }}
            >
              {params.value}
            </Box>
          );
        }
      },
    },
    {
      field: 'consignmentReference',
      headerName: 'Consignment Ref',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      renderCell: (params) => {
        if (params.row.status.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                color: '#E61610',
              }}
            >
              {params.value}
            </Box>
          );
        }
      },
    },
    {
      field: 'totalItemsCounts',
      headerName: 'Number of Lines',
      type: 'number',
      flex: 1,
      editable: false,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'theme--header',
      renderCell: (params) => {
        if (params.row.status.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                color: '#E61610',
              }}
            >
              {params.value}
            </Box>
          );
        }
      },
    },
    {
      field: 'mrn',
      headerName: 'MRN',
      flex: 1,
      editable: false,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'theme--header',
      renderCell: (params) => {
        if (params.value?.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                color: '#E61610',
              }}
            >
              {params.value}
            </Box>
          );
        }
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      editable: false,
      headerClassName: 'theme--header',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        if (params.row.status.toUpperCase() === 'ERRORS') {
          return (
            <Box
              sx={{
                color: '#E61610',
                fontWeight: 'bold',
              }}
            >
              {params.value}
            </Box>
          );
        }
        return <Box sx={{ fontWeight: 'bold' }}>{params.value}</Box>;
      },
    },
    {
      field: '23',
      headerName: '',
      width: 50,
      editable: false,
      headerClassName: 'theme--header',
      renderCell: (params) => (
        <div onClick={() => navigatetoENS(params.row)}>
          <ExitToAppIcon style={{ color: '#1464F6' }} />
        </div>
      ),
    },
  ];
  const navigatetoENS = (row) => {
    navigate('/EnsDeclaration', {
      state: {
        consignmentId: row.id,
        companyId: state.companyId,
        headerId: state.res,
        error: row.status.toUpperCase() === 'ERRORS' ? true : false,
        image: logoImage,
        currentCompany: companyName,
        isReadOnly,
      },
    });
  };
  const navigateToUpdateENS = () => {
    navigate('/EnsDeclaration', {
      state: { activeStep: 'Consignments', headerId: state.res, companyId: state.companyId, isReadOnly },
    });
  };
  const handleClose = () => setOpen(false);
  const showErrorModal = () => {
    try {
      setOpen(true);
      getErrorsDetails(state.res).then((data) => {
        setErrorData(data.data);
      });
    } catch (e) {
      console.error(e);
    }
  };
  const deleteShipmentCall = async () => {
    try {
      setDeleteShipmentModalOpen(true);
      //deleteShipment(state.res)
    } catch (e) {
      console.log(e);
    }
  };
  const duplicateShipmentCall = async () => {
    try {
      setDuplicateModalOpen(true);
      //duplicateShipment(state.res)
    } catch (e) {
      console.log(e);
    }
  };
  const printPageClick = () => {
    navigate('/printShipment', {
      state: { shipmentDataView: shipmentDataView, consignmentDataView: consignmentDataView },
    });
  };
  return (
    <Container
      maxWidth="xl"
      sx={{
        mt: 6,
        mb: 6,
      }}
    >
      <div className="stepper-wrapper-tabs-dashboard">
        <DashboardHeaderShipment
          accountDetails="Shipment View"
          result={store.shipmentData[0]}
          isReadOnly={isReadOnly}
        />
        <Stack direction="row" gap={2} className="stepper-wrapper-tabs">
          <div className="rowWrapper col-container shipment-view">
            {(isError || isRejected) && (
              <>
                <Tabs
                  className="wrapper-tabs"
                  orientation="vertical"
                  value={value}
                  onChange={(_event, newValue) => setValue(newValue)}
                >
                  <div className="shiipment-information-required">Shipment Action Required</div>
                  {isError && (
                    <Tab
                      className="no-uppercase"
                      label="View errors on this shipment"
                      {...a11yProps(0)}
                      onClick={showErrorModal}
                    />
                  )}
                  {isRejected && (
                    <Tab
                      className="no-uppercase"
                      label="View rejected on this shipment"
                      {...a11yProps(0)}
                      onClick={showErrorModal}
                    />
                  )}
                </Tabs>
              </>
            )}

            <Tabs
              className="wrapper-tabs"
              orientation="vertical"
              value={value}
              onChange={(_event, newValue) => setValue(newValue)}
              TabIndicatorProps={{ style: { display: 'none' } }}
            >
              <div className="shipment-actions">Shipment Actions</div>
              {acceptedStated && <Tab label="Print this Shipment" {...a11yProps(0)} onClick={printPageClick} />}
              <Tab
                label="Duplicate this Shipment"
                {...a11yProps(0)}
                onClick={duplicateShipmentCall}
                disabled={isReadOnly}
              />
              <Tab label="Delete Shipment" {...a11yProps(1)} onClick={deleteShipmentCall} disabled={isReadOnly} />
              <Tab label="Refresh Status" onClick={() => setRefreshStatusModalOpen(true)} disabled={isReadOnly} />
            </Tabs>

            <Tabs
              className="wrapper-tabs"
              orientation="vertical"
              value={value}
              onChange={(_event, newValue) => setValue(newValue)}
              TabIndicatorProps={{ style: { display: 'none' } }}
            >
              <div>
                <div className="shipment-actions ">Consignment Actions</div>
              </div>
              <Tab label="Update a Consignment" {...a11yProps(0)} onClick={navigateToUpdateENS} disabled={isReadOnly} />
            </Tabs>
          </div>

          <div className="rowWrapper shipment-view-wrapper">
            <Paper sx={{ width: '100%' }}>
              <DataGridPro
                hideFooter
                rows={shipmentDataView}
                columns={columns}
                getRowId={(row) => row && row.headerId}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[20, 50, 100]}
                sx={{ border: 0 }}
                onRowClick={handleClick}
                getRowClassName={(params) => {
                  return params.row.status.toUpperCase() === 'ERRORS' ? 'highlight' : 'non-highlight';
                }}
              />
            </Paper>
            <div
              style={{
                textAlign: 'left',
                fontSize: '20px',
                fontWeight: 'bold',
                marginBottom: '10px',
                width: '100%',
                marginTop: '20px',
              }}
            >
              Consignment Details
            </div>
            <Paper sx={{ width: '100%' }}>
              <DataGridPro
                pagination
                rows={consignmentDataView}
                columns={consignmentColumns}
                getRowId={(row) => row && Math.floor(Math.random() * 100000000)}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[20, 50, 100]}
                sx={{ border: 0 }}
                onRowClick={handleClickConsignment}
              />
            </Paper>
          </div>
        </Stack>
        <Dialog
          open={open}
          onClose={handleClose}
          className="ShipmentView"
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();

              handleClose();
            },
          }}
        >
          <DialogTitle>
            <span>
              <WarningIcon style={{ color: 'red' }} />
            </span>{' '}
            HMRC Errors
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <p>Errors received on this shipment</p>
              <TableContainer>
                <Table
                  aria-label="simple table"
                  sx={{
                    [`& .${tableCellClasses.root}`]: {
                      borderBottom: 'none',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Error</TableCell>
                      <TableCell align="right">Occurrence(s)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {errorData.map((row) => (
                      <TableRow key={row.errorCode}>
                        <TableCell component="th" scope="row">
                          {row.scenario}
                        </TableCell>
                        <TableCell align="right">{row.occurrenceCount}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <p>Please select the consignment to review and correct the error(s)</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
        <DuplicateModal open={duplicateModalOpen} onClose={() => setDuplicateModalOpen(false)} headerId={state.res} />
        <DeleteShipmentModal
          open={deleteShipmentModalOpen}
          onClose={() => setDeleteShipmentModalOpen(false)}
          headerId={state.res}
          reference={shipmentDataView[0]?.clientJobNumber}
        />
        <RefreshStatusModal
          isOpen={refreshStatusModalOpen}
          setIsOpen={setRefreshStatusModalOpen}
          headerId={state.res}
          onRefreshData={() => setShouldFetchData(true)}
        />
      </div>
    </Container>
  );
}
ShipmentView.propTypes = {
  countForApi: PropTypes.string,
};
